import(/* webpackMode: "eager" */ "/opt/script/frontend/senegaljoogjob/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/opt/script/frontend/senegaljoogjob/src/app/contact/contact.module.css");
